function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85.1 33.2",
    style: {
      enableBackground: "new 0 0 85.1 33.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 1974,
    height: 1701,
    id: "\\u56FE\\u5C42_3",
    xlinkHref: "27E1A6379468DD86.png",
    transform: "matrix(1.676313e-02 0 0 1.791433e-02 1.101685e-02 0.7648)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 817,
    height: 340,
    id: "\\u56FE\\u5C42_11",
    xlinkHref: "27E1A6379468DD8A.png",
    transform: "matrix(1.532254e-02 0 0 1.637481e-02 72.4925 26.8492)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 544,
    height: 340,
    id: "\\u56FE\\u5C42_10",
    xlinkHref: "27E1A6379468DD8D.png",
    transform: "matrix(1.329587e-02 0 0 1.420896e-02 56.8319 27.1447)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 681,
    height: 272,
    id: "\\u56FE\\u5C42_9",
    xlinkHref: "27E1A6379468DD8E.png",
    transform: "matrix(1.641048e-02 0 0 1.753747e-02 38.2785 27.9946)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 2654,
    height: 340,
    id: "\\u56FE\\u5C42_8",
    xlinkHref: "27E1A6379468DD8C.png",
    transform: "matrix(1.640536e-02 0 0 1.753200e-02 39.8799 15.7158)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 544,
    height: 613,
    id: "\\u56FE\\u5C42_7",
    xlinkHref: "27E1A6379468DD8B.png",
    transform: "matrix(1.467682e-02 0 0 1.568474e-02 64.8411 22.203)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 408,
    height: 613,
    id: "\\u56FE\\u5C42_6",
    xlinkHref: "27E1A6379468DD85.png",
    transform: "matrix(1.488645e-02 0 0 1.590876e-02 50.4242 22.1524)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 340,
    height: 613,
    id: "\\u56FE\\u5C42_5",
    xlinkHref: "27E1A6379468DD87.png",
    transform: "matrix(1.504767e-02 0 0 1.608106e-02 32.7445 22.0815)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 408,
    height: 544,
    id: "\\u56FE\\u5C42_4",
    xlinkHref: "27E1A6379468DD84.png",
    transform: "matrix(1.648209e-02 0 0 1.761398e-02 32.5367 11.055)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.159c9af5efb447f40c124039454d5bd3.svg";
export { ForwardRef as ReactComponent };